/* eslint-disable max-len */
import { ReactElement } from 'react';
import NPSE_AddCoursePanel from './NPSE_AddCoursePanel';

const NPSE_ScheduleLayout = (): ReactElement => {
  return <NPSE_AddCoursePanel />;
};

export default NPSE_ScheduleLayout;
